/* LabelLab — header predictive search (handoff §5).
   Idempotent: no-op if #searchDrop is absent. Data from a static JSON feed
   (assets/search-data.json) referenced via #searchDrop[data-feed]. */
(function () {
  var drop = document.getElementById('searchDrop');
  if (!drop) return;

  var toggle   = document.getElementById('searchToggle');
  var scrim    = document.getElementById('searchScrim');
  var input    = document.getElementById('searchInput');
  var closeBtn = document.getElementById('searchClose');
  var hint     = document.getElementById('searchHint');
  var results  = document.getElementById('searchResults');

  var PRODUCTS = [];
  var loaded = false, loading = false;

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function highlight(name, q) {
    if (!q) return escapeHtml(name);
    var i = name.toLowerCase().indexOf(q.toLowerCase());
    if (i < 0) return escapeHtml(name);
    return escapeHtml(name.slice(0, i)) + '<b>' + escapeHtml(name.slice(i, i + q.length)) + '</b>' + escapeHtml(name.slice(i + q.length));
  }

  function render(q) {
    q = (q || '').trim();
    if (!q) { results.innerHTML = ''; hint.style.display = 'block'; return; }
    hint.style.display = 'none';
    if (!loaded) { results.innerHTML = '<li class="search-empty">Loading…</li>'; return; }
    var ql = q.toLowerCase();
    var matches = PRODUCTS.filter(function (p) {
      return p.name.toLowerCase().indexOf(ql) > -1
          || (p.cat || '').toLowerCase().indexOf(ql) > -1
          || (p.gsm || '').toLowerCase().indexOf(ql) > -1;
    });
    if (matches.length === 0) {
      results.innerHTML = '<li class="search-empty">No matches for <b>“' + escapeHtml(q) + '”</b>. Try a garment type — tee, hoodie, cap — or a weight like “220”.</li>';
      return;
    }
    results.innerHTML = matches.map(function (p, idx) {
      return '<a class="sr-item" href="' + escapeHtml(p.href) + '" style="animation-delay:' + (idx * 22) + 'ms">' +
        '<span class="sr-thumb" style="background-image:url(\'' + escapeHtml(p.thumb) + '\')"></span>' +
        '<span class="sr-text"><span class="sr-name">' + highlight(p.name, q) + '</span>' +
        '<span class="sr-cat">' + escapeHtml(p.cat) + (p.gsm ? ' · ' + escapeHtml(p.gsm) : '') + '</span></span>' +
        '<span class="sr-price">' + escapeHtml(p.price) + '</span>' +
        '</a>';
    }).join('');
  }

  function loadFeed() {
    if (loaded || loading) return;
    var url = drop.getAttribute('data-feed');
    if (!url) return;
    loading = true;
    fetch(url).then(function (r) { return r.json(); }).then(function (data) {
      PRODUCTS = Array.isArray(data) ? data : [];
      loaded = true; loading = false;
      if (drop.classList.contains('open')) render(input.value);
    }).catch(function () { loading = false; });
  }

  function open() {
    loadFeed();
    drop.classList.add('open');
    if (scrim) scrim.classList.add('open');
    if (toggle) toggle.classList.add('active');
    setTimeout(function () { input.focus(); }, 30);
  }
  function close() {
    drop.classList.remove('open');
    if (scrim) scrim.classList.remove('open');
    if (toggle) toggle.classList.remove('active');
    input.value = '';
    render('');
  }

  if (toggle) toggle.addEventListener('click', function (e) {
    e.preventDefault();
    drop.classList.contains('open') ? close() : open();
  });
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (scrim) scrim.addEventListener('click', close);
  input.addEventListener('input', function () { render(input.value); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drop.classList.contains('open')) close();
  });
})();
